<template>
    <Portlet :fullHeight="true">
        <template slot="Title">
            Planner - Home
        </template>
        <template slot="Options">
        </template>
        <template slot="Content">
            <p>Welcome to your planner</p>
            <WaitingBlock v-if="isLoadingStations">
            </WaitingBlock>
            <div v-else>
                <h1>Your stations</h1>
                <p>Choose a station</p>
                <router-link tag="div" 
                             :to="{name:'StationPlanner', params:{radiouid:station.uid} }" 
                             v-for="station in userStations.items"
                             :key="station.uid">
                    <template>
                        <a>{{station.name}} - {{station.uid}}</a>
                    </template>
                </router-link>
                <h1>{{currentStation}}</h1>
                <h1>{{currentRadio}}</h1>
            </div>
        </template>
    </Portlet>
</template>

<script>
    import Vue from 'vue'
    import Portlet from '@/components/common/Portlet.vue'
    import Button from '@/components/common/Button.vue'
    import WaitingBlock from '@/components/common/WaitingBlock.vue'
    import { mapState, mapGetters } from 'vuex'

    export default {
        name: 'Home',
        components: { Portlet, WaitingBlock },
        computed: {
            ...mapGetters(["currentRadio"]),
            ...mapState({
                userStations: function (state) {
                    return state.stations || { count: 0, items: [] };
                },
                isLoadingStations: function (state) { return state.loadingStates.isLoadingStations }
            }),
            currentStation: function () { return this.currentRadio; },
        },
        props: {
            msg: String
        }
    };
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    a {
        text-decoration: none;
        color: #d2d2d2;
    }

    .router-link-exact-active a, .router-link-active a {
        color: #000000;
    }
</style>
